import { UserProps } from '../../../constants/Common';
import { FirebaseApi } from '../../../firebase/firebaseApi';
import { useReportsContext } from '../ReportsPageWrapper';
import { ActivitiesReportFirebaseCalls } from '../StateManagement/models';
import { ActivitiesReport } from './ActivitiesReport';

type AvailableFirebaseCalls = Extract<
	keyof FirebaseApi,
	ActivitiesReportFirebaseCalls
>;

export const ActivitiesReportWrapper = ({
	userDetails,
}: UserProps): JSX.Element => {
	const {
		context: { startDate, endDate, firebaseApi },
		dispatch,
	} = useReportsContext<AvailableFirebaseCalls>();

	return (
		<ActivitiesReport
			userDetails={userDetails}
			startDateContext={{
				date: startDate,
				setDate: (value): void => dispatch({ key: 'startDate', value }),
			}}
			endDateContext={{
				date: endDate,
				setDate: (value): void => dispatch({ key: 'endDate', value }),
			}}
			firebaseApi={firebaseApi}
		/>
	);
};
